import * as Sentry from "@sentry/react";

/**
 * Error reporting, decoupled from the underlying provider (currently Sentry).
 *
 * Call `reportError` anywhere an error is caught and handled locally — a
 * global query/mutation failure, a swallowed `catch`, a manual retry path —
 * instead of calling the Sentry SDK directly. This is the only file (besides
 * `sentry.ts`, which only initializes the SDK) that should import from
 * "@sentry/react" to capture an error, so swapping providers later means
 * changing this file, not every call site.
 */
export type ErrorReportContext = {
  /** Freeform key/value pairs attached to the event for triage — a query key, mutation variables, etc. */
  extra?: Record<string, unknown>;
  /** Short, filterable labels, e.g. { feature: "plow-report-download" }. */
  tags?: Record<string, string | number | boolean>;
};

export const reportError = (
  error: unknown,
  context?: ErrorReportContext,
): void => {
  Sentry.captureException(error, context);
};
